/* eslint-disable sort-keys */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserInfo } from '../../auth';
import { useApiDelete, useApiPost, useApiQuery } from '../../query';

export type FavoriteProductIds = {
  productIds: string[];
};

export type ModifyFavoriteRequest = {
  sku: string;
};

export function useFavoriteProductIds() {
  const userInfo = useUserInfo();
  const url = `/product/v1/users/${
    userInfo && userInfo.preferred_username
  }/favoriteproductids`;
  return useApiQuery<FavoriteProductIds>(url, undefined);
}

export function useAddToFavoriteMutation() {
  const apiPost = useApiPost<boolean>();
  const queryClient = useQueryClient();
  const userInfo = useUserInfo();

  return useMutation({
    mutationFn: (sku: string) => {
      const requestAddToFavorite: ModifyFavoriteRequest = {
        sku: sku,
      };
      const data = apiPost(
        '/product/v1/users/favorite-product',
        requestAddToFavorite
      );
      return data;
    },
    onSuccess: () => {
      const productIdsurl = `/product/v1/users/${
        userInfo && userInfo.preferred_username
      }/favoriteproductids`;
      queryClient.invalidateQueries({ queryKey: [productIdsurl] });

      const prodcuctsUrl = `/product/v1/users/${
        userInfo && userInfo.preferred_username
      }/favoriteproducts`;
      queryClient.invalidateQueries({ queryKey: [prodcuctsUrl] });
    },
    onError: (error) => {
      console.error(error);
    },
  });
}

export function useDeleteFavoriteMutation() {
  const apiDelete = useApiDelete<boolean>();
  const queryClient = useQueryClient();
  const userInfo = useUserInfo();

  return useMutation({
    mutationFn: (sku: string) => {
      const requestAddToFavorite: ModifyFavoriteRequest = {
        sku: sku,
      };
      const data = apiDelete(
        '/product/v1/users/favorite-product',
        requestAddToFavorite
      );
      return data;
    },
    onSuccess: () => {
      const productIdsurl = `/product/v1/users/${
        userInfo && userInfo.preferred_username
      }/favoriteproductids`;
      queryClient.invalidateQueries({ queryKey: [productIdsurl] });

      const productsUrl = `/product/v1/users/${
        userInfo && userInfo.preferred_username
      }/favoriteproducts`;
      queryClient.invalidateQueries({ queryKey: [productsUrl] });
    },
    onError: (error) => {
      console.error(error);
    },
  });
}
